// extracted by mini-css-extract-plugin
export default {"toggler":"SiderToggler_toggler__mRnmd"};